<template>
  <div class="page-content">
    <section>
      <div
        class="
          content-wrap
        "
        style="
          margin-bottom: 0;
        ">
        <label
          style="
            font-size: 1rem;
          ">
          <b>
            ค้นหาบ้าน
          </b>
        </label>
        <div
          class="
            filter input-text
          ">
          <input
            type="text"
            class="
              el-input__inner
            "
            v-model="
              search.text
            "
            @keyup.enter="
              () => fetchHome(search.text, 1)
            "
            :placeholder="
              'ค้นหาเลขที่อยู่'
            "
          />
          <el-button
            type="sc-asset"
            icon="
              el-icon-search
            "
            @click="
              () => fetchHome(search.text, 1)
            ">
            ค้นหา
          </el-button>
        </div>
      </div>
    </section>

    <section>
      <div
        class="
          content-wrap content-main
        ">
        <p>
          พบ <b>{{ paging.total }}</b> รายการ
        </p>
        <div
          v-if="
            paging.total == 0
          "
          class="empty">
          <img
            src="@/assets/images/admin/empty.png"
          />
          <p>
            <b class="unknown">
              ไม่พบข้อมูล
            </b>
          </p>
        </div>
        <div
          v-if="
            paging.total > 0
          "
          class="home-list">
          <div
            v-for="
              (item, i) in items
            "
            :key="i"
            class="item">
            <div
              class="
                item-content
              ">
              <div class="item-icon">
                <img
                  :src="
                    item.projectIcon
                  "
                  @error="
                    event => imgError(event)
                  "
                />
              </div>
              <div class="item-detail">
                <b>
                  เลขที่ {{ item.addressNo }}
                </b>
                <p
                  class="
                    subtitle ellipsis
                  ">
                  โครงการ{{ item.projectName }}
                </p>
              </div>
            </div>
            <el-button
              type="sc-asset"
              icon="
                el-icon-edit-outline
              "
              @click="
                () => edit(item.id)
              ">
              เปิด
            </el-button>
          </div>
        </div>
        <div
          v-if="
            paging.total > 0
          "
          class="pager">
          <el-pagination
            :background="true"
            :layout="
              'prev, pager, next'
            "
            @current-change="
              (page) => fetchHome(
                search.text, page
              )
            "
            :pager-count="
              paging.count
            "
            :current-page="
              paging.page
            "
            :page-size="
              paging.limit
            "
            :total="
              paging.total
            "
          />
        </div>
      </div>
    </section>
    
    <!-- Loader -->
    <div 
      v-loading.fullscreen.lock="loader"
      element-loading-background="rgba(0, 0, 0, 0.4)">
    </div>

  </div>
</template>

<script>

// Feature
import { NonScFeature } from '../../feature'

export default {
  data () {
    
    // Init Title
    const title = 'รายการบ้าน'

    // Init Loader
    const loader = false

    // Init Search
    const search = {
      text: null
    }
    
    // Init Paging
    const paging = {
      page  : 1,
      limit : 10,
      count : 5,
      total : 0,
    }

    // Init Home
    const home = []

    return {
      title,
      loader,
      home,
      search,
      paging,
    }
  },
  computed: {
    clientHome() {
      return NonScFeature.home
    },
    items() {

      const toItem = (value) => {

        // Default Result
        const result = {
          id          : null,
          addressNo   : null,
          projectIcon : null,
          projectName : null,
          projectCode : null,
        }

        // Home Props
        const {
          id, address, project
        } = value

        // Set Home ID
        if (id) result.id = id

        // Set Address
        if (address) {
          result.addressNo = address.addressNo
        }

        // Set Project 
        if (project) {

          // Project Props
          const {
            name: projectName,
            code: projectCode,
            icon: projectIcon
          } = project

          // Set Project
          Object.assign(
            result, {
              projectName, projectCode, projectIcon
            }
          )
        }

        return result
      }

      return this.home.map(toItem)
    }
  },
  mounted() {

    // Init Title
    this.$emit(
      'sub-title', this.title
    )

    // Init Home
    this.fetchHome()
  },
  methods: {
    imgError(e) {
      e.target.src = 'https://www.scasset.com/images/sca-orange.svg'
    },
    edit(homeId) {

      // Route Parameters
      const params = { homeId }

      // Forward Route
      this.$router.push({
        name: 'nonsc-home-detail', params
      })
    },
    async fetchHome(text = '', page = 1) {
      
      // Loading
      this.loader = true

      try {
        
        // Paging Props
        const { limit } = this.paging

        // Fetch Params
        const params = {
          text, page, limit
        }
        
        // Fetch Home
        const { total, items } = (
          await this.clientHome.list(params)
        )

        // Set Home
        this.home = items
        
        // Set Paging
        Object.assign(
          this.paging, { page, total }
        )
      }
      catch (_) {
        
        // Reset Home
        this.home = []
        
        // Reset Paging
        Object.assign(
          this.paging, { page: 1, total: 0 }
        )
      }
      finally {
        setTimeout(
          () => this.loader = false, 400
        )
      }
    },
  }
}
</script>

<style lang="css" scoped>

section .content-wrap {
  background: white;
}

.content-main {
  display : grid;
  gap     : var(--size-md);
}

.home-list {
  display               : grid;
  gap                   : var(--size-sm);
  grid-template-columns : repeat(2, 1fr);
}

.item {
  padding     : var(--size-sm);
  gap         : var(--size-sm);
  overflow    : hidden;
  align-items : center;
}

.item-content {
  flex        : 1;
  display     : flex;
  align-items : center;
  gap         : var(--size-sm);
  overflow    : hidden;
}

.item-icon {
  flex: none;  
}
.item-detail {
  flex      : 1;
  overflow  : hidden;
}

.item-icon img {
  width         : 4rem;
  aspect-ratio  : 1/1;
  object-fit    : cover;
  border-radius : var(--size-xs);
}

.filter {
  display : flex;
  gap     : var(--size-sm);
}

@media screen and (max-width: 1280px) {
    
  .home-list {
    grid-template-columns: 1fr;
  }
}

</style>



// WEBPACK FOOTER //
// src/features/nonsc/pages/home/NonScHomeList.vue